// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d36e81b1","455":"e3d7b8b8","977":"abc96572"}[chunkId] + ".chunk.js";
};